module.exports = __webpack_public_path__ + "img/logo.08af87ea.png";